<script setup lang="ts">
definePage({
  path: '/sales/sales-metrics',
  name: '/sales/SalesMetrics',
  meta: {
    title: 'Sales Input Metrics',
    permission: {
      resource: 'SalesMetrics',
      level: 'Read',
    },
  },
})

const router = useRouter()
const route = useRoute()

onBeforeMount(() => {
  if ((route.name as any) === '/sales/SalesMetrics') {
    router.replace({ name: '/sales/SalesMetrics/my-logs' as any })
  }
})

watch(() => route.name, (name) => {
  if ((name as any) === '/sales/SalesMetrics') {
    router.replace({ name: '/sales/SalesMetrics/my-logs' as any })
  }
})

const tabs = [
  {
    label: 'Mijn Logs',
    name: '/sales/SalesMetrics/my-logs',
  },
  {
    label: 'Pipeline',
    name: '/sales/SalesMetrics/pipeline',
  },
  {
    label: 'Statistieken',
    name: '/sales/SalesMetrics/statistics',
  },
  {
    label: 'Forecast',
    name: '/sales/SalesMetrics/forecast',
  },
  {
    label: 'Abonnementen',
    name: '/sales/SalesMetrics/subscriptions',
  },
  {
    label: 'Demo\'s',
    name: '/sales/SalesMetrics/all-demos',
  },
  {
    label: 'Doelen',
    name: '/sales/SalesMetrics/goals',
  },
  {
    label: 'Daily Logs',
    name: '/sales/SalesMetrics/all-logs',
  },
]
</script>

<template>
  <div class="space-y-5">
    <Tabs :value="route.name" scrollable>
      <TabList>
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="{ name: tab.name as any }"
        >
          <Tab :value="tab.name">
            {{ tab.label }}
          </Tab>
        </router-link>
      </TabList>
    </Tabs>

    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
</template>
